import axios from "axios";
import { logAPI } from "../constants/apis";
import { LOG_MESSAGES, STORAGE_KEYS } from "../../utils/constants";
import { getDeviceInfo } from "../../utils/deviceInfo";

/**
 * sendLog — POST an event to the CRM /logs/ endpoint.
 *
 * Pattern mirrored from GloTV (glotv-main/src/GLOBAL/redux/account.js).
 *
 * Endpoint: POST {CRM}/logs/?operator_uid={op}
 * Fire-and-forget: errors are swallowed so logging never breaks UX.
 *
 * @param {Object} data
 * @param {"login"|"logout"|"play"|"search"|"quit"} data.action
 * @param {string} [data.content_uid]       content UID (play events)
 * @param {"movie"|"series"|"live"} [data.content_type]
 * @param {string} [data.content_name]      movie/episode title or search query
 * @param {number|string} [data.duration]   playback duration in seconds
 */
export const sendLog = async (data) => {
  const { action, content_uid, content_type, content_name, duration } = data || {};

  try {
    const device = getDeviceInfo();
    const subscriber_uid =
      window.localStorage.getItem(STORAGE_KEYS.USERNAME) || "anonymous";

    let logMessage = "";
    if (action === "login") logMessage = LOG_MESSAGES.login;
    else if (action === "logout") logMessage = LOG_MESSAGES.logout;
    else if (action === "search") logMessage = LOG_MESSAGES.search;
    else if (action === "quit") logMessage = LOG_MESSAGES.quit;
    else if (action === "play") {
      if (content_type === "series") logMessage = LOG_MESSAGES.playSeries;
      else if (content_type === "live") logMessage = LOG_MESSAGES.playLive;
      else logMessage = LOG_MESSAGES.playMovie;
    }

    let durationInt = 0;
    if (duration !== undefined && duration !== null) {
      const raw = typeof duration === "string" ? duration.replace(",", "") : duration;
      const parsed = Number(raw);
      if (!Number.isNaN(parsed)) durationInt = parsed;
    }

    const requestData = {
      subscriber_uid,
      device_id: device.device,
      device_type: device.device_type || "Desktop",
      device_name: device.device_type || "Web Browser",
      platform: device.device_os,
      action,
      content_uid: content_uid || "",
      content_type: content_type || "",
      content_name: content_name || "",
      content_details: logMessage,
      duration: durationInt,
      medium: "Web",
    };

    console.log("[sendLog] posting event:", action, requestData);
    const response = await axios.post(logAPI(), requestData);
    console.log("[sendLog] response:", response.data?.status || response.status);
    return response.data;
  } catch (e) {
    console.warn("[sendLog] failed:", e.message);
    return null;
  }
};

export default sendLog;
